import { render } from "./controls.vue?vue&type=template&id=6f5b78e9"
import script from "./controls.vue?vue&type=script&lang=js"
export * from "./controls.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/controls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f5b78e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f5b78e9', __exports__)) {
    api.reload('6f5b78e9', __exports__)
  }
  
  module.hot.accept("./controls.vue?vue&type=template&id=6f5b78e9", () => {
    api.rerender('6f5b78e9', render)
  })

}


export default __exports__